import React from 'react';
import PropTypes from 'prop-types';
import View from '@loggi/ui/components/view';
import Text, { TEXT_SIZE_LARGE } from '@loggi/ui/components/text';
import Button from '@loggi/ui/components/button';
import icons from '@loggi/ui/components/utils/icons';

import styles from './confirm-delivery.styles.scss';

const ConfirmDeliveryHeader = props => {
  const BackButton = onClickBackButton => {
    return (
      <Button
        data-testid="back-btn"
        size="large"
        className="backButton"
        icon={icons.type.SHORT_ARROW_LEFT}
        style="link"
        onClick={onClickBackButton}
      />
    );
  };

  const { headerText, className, onClickBack } = props;

  return (
    <View
      flex
      flexDirection="column"
      justifyContent="start"
      alignItems="start"
      className={`${styles.header} ${className}`}
      gutter={{
        top: 'double',
        right: 'double'
      }}
    >
      <View className="actionButtons">{BackButton(onClickBack)}</View>
      <View
        gutter={{
          left: 'double'
        }}
      >
        <Text size={TEXT_SIZE_LARGE}>{headerText}</Text>
      </View>
    </View>
  );
};

ConfirmDeliveryHeader.propTypes = {
  headerText: PropTypes.string,
  className: PropTypes.string,
  onClickBack: PropTypes.func.isRequired
};

ConfirmDeliveryHeader.defaultProps = {
  headerText: null,
  className: null
};

export default ConfirmDeliveryHeader;
